import * as React from "react";
import Modal from "../../ui/modal/Modal";
import EditLeadStatusForm from "../form/edit/EditLeadStatusForm";
import LeadStatus from "../../../model/lead/LeadStatus";

interface IComponentProps {
	/**
	 * On successful edited lead status callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Lead status to edit
	 */
	editedLeadStatus: LeadStatus;
}

export default class EditLeadStatusModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal autoWidth onCloseClicked={this.props.onCancel} title={"Edit Lead Status"}>
				<EditLeadStatusForm onSuccess={this.props.onSuccess} onCancel={this.props.onCancel}
									editedLeadStatus={this.props.editedLeadStatus}/>
			</Modal>
		);
	}
}
